export const endsWith = (target, ...subs) => subs
  .map(s => target.endsWith(s))
  .reduce((p, c) => p || c);